import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Header from 'components_library/molecules/Header/Header';
import Tabs from 'components_library/molecules/Tabs/Tabs';
import MoreButton from 'components_library/molecules/MoreButton/MoreButton';
import PageNavigation from 'components_library/molecules/PageNavigation/PageNavigation';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import s from './Section.scss';

const Section = props => {
  const {
    children,
    header,
    tabs,
    footer = {},
    onTabsChangeCallback,
    hideMoreStories,
    loading,
    ga,
    typeShemaClassNames,
    paginationData,
    location,
  } = props;

  if (!React.isValidElement(children)) {
    return null;
  }
  const [currentPage, setCurrentPage] = useState(1);

  const [activeTab, setActiveTab] = useState(
    Array.isArray(tabs) && tabs.length ? tabs[0].name : '',
  );

  const onTabsChange = params => {
    const { clickedItem: { name } } = params;
    if (
      params &&
      params.clickedItem &&
      params.clickedItem.dataUrl &&
      typeof onTabsChangeCallback === 'function'
    ) {
      onTabsChangeCallback(params.clickedItem.dataUrl, true);
    }
    if (params.clickedItem.name) {
      setActiveTab(name);
    }
  };

  const loadMoreData = (event, dataUrl) => {
    let nextUrl = dataUrl;
    if (dataUrl && typeof dataUrl === 'string') {
      nextUrl =
        dataUrl +
        (dataUrl.includes('?')
          ? `&curpg=${currentPage + 1}`
          : `?curpg=${currentPage + 1}`);
    }
    setCurrentPage(currentPage + 1);
    event.preventDefault();
    if (typeof onTabsChangeCallback === 'function') {
      onTabsChangeCallback(nextUrl, true, true);
    }
  };

  const isTabsPresent = Array.isArray(tabs) && tabs.length > 1;
  const { moreData } = footer;

  const showPaginationWidget =
    currentPage &&
    currentPage === 1 &&
    paginationData &&
    paginationData.leafNode &&
    paginationData.totalStories &&
    paginationData.storiesPerPage;

  const totalPages = showPaginationWidget
    ? Math.ceil(paginationData.totalStories / paginationData.storiesPerPage)
    : 0;

  return (
    <div className={s.content_wrapper}>
      {loading && <LoaderSpinner />}
      {header && (
        <Header {...header} ga={ga} typeShemaClassNames={typeShemaClassNames}>
          {isTabsPresent && (
            <Tabs
              tabs={tabs}
              onChangeCallback={onTabsChange}
              active={activeTab}
              ga={ga}
              typeShemaClassNames={typeShemaClassNames}
            />
          )}
        </Header>
      )}
      {React.isValidElement(children) && children}
      {showPaginationWidget &&
        totalPages > 1 && (
          <PageNavigation
            location={location}
            {...paginationData}
            currentPage={1}
          />
        )}
      {!showPaginationWidget &&
        moreData &&
        moreData.baseUrl &&
        !hideMoreStories && (
          <MoreButton
            isNoLink
            onClick={event => {
              loadMoreData(event, moreData.baseUrl);
            }}
            ga={ga}
            typeShemaClassNames={typeShemaClassNames}
          />
        )}
      {!showPaginationWidget &&
        moreData &&
        !moreData.baseUrl &&
        moreData.link && (
          <MoreButton
            moreText={moreData.text}
            moreLink={moreData.link}
            ga={ga}
            typeShemaClassNames={typeShemaClassNames}
          />
        )}
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.shape({}),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      dataUrl: PropTypes.string.isRequired,
    }),
  ),
  footer: PropTypes.shape({
    moreData: PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  }),
  onTabsChangeCallback: PropTypes.func,
  hideMoreStories: PropTypes.bool,
  loading: PropTypes.bool,
  ga: PropTypes.shape({}),
  paginationData: PropTypes.shape({}),
};

Section.defaultProps = {
  header: null,
  tabs: [],
  footer: {},
  onTabsChangeCallback: () => {},
  hideMoreStories: false,
  loading: false,
  ga: undefined,
  paginationData: undefined,
};

export default Section;
